export default __webpack_public_path__ + "static/subset-UniNeueHeavy-Italic-2622c8a0020e481789fedaf4e645d6e1.woff2";